import React                           from 'react';
import { Link }                        from 'react-router-dom';
import PropTypes                       from 'prop-types';
import classNames                      from 'classnames';
import LocaleString                    from '../../shared/locale-string';
import { activityIndicatorHtml }       from '../../shared/activity-indicator/activity-indicator.jsx';
import {
    ChevronDownIcon,
    LogoutIcon,
    ExperiencesIcon,
    MerchandiseIcon
} from '../icons/icons.jsx';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import './header.scss';

class Header extends React.Component {

    handleLogout = event => {
        event.preventDefault();
        this.props.logout();
    };

    handleShopClick = event => {
        event.preventDefault();
        const type = event.currentTarget.dataset.type;

        if ( !this.props.user.adminAsUser ) {
            const newTab = window.open( '', '_blank' );
            newTab.document.body.innerHTML = activityIndicatorHtml;

            this.props.fetchCatalogUrl( type )
                .then( catalogUrl => {
                    newTab.location.href = catalogUrl;
                    newTab.focus();
                } )
                .catch( error => {
                    newTab.close();
                    throw error;
                } );
        }
    };

    render () {
        const {
            clientLogo,
            user,
            mediaLabel
        } = this.props;

        const locale = user.locale.code;
        const balance = new Intl.NumberFormat( locale ).format( user.accountBalance );
        const headerClasses = classNames( {
            'header': true,
            'public': !user.authenticated,
            'launched-as': user.adminAsUser
        } );

        const logo = clientLogo && <img src={ clientLogo } alt="PRO Accounts" />;
        const userHeader = user.userId && <UserHeader user={ user } handleLogout={ this.handleLogout } />;
        const shopSeparator = !user.rewardsOfferingUnavailable && <div className="separator"></div>;

        return (
            <div className={ headerClasses }>

                { userHeader }

                <div className="container">
                    <span className="logo-wrap">{ logo }</span>

                    { user.userId &&
                        <div className="header-links">
                            <Link to="/activity-history" className="points-display">
                                <span className="points">{ balance }</span>
                                <span className="label">{ mediaLabel }</span>
                            </Link>

                            { shopSeparator }

                            <div className="shop-links">
                                <Tippy
                                    interactive
                                    className="redeem-menu-dropdown"
                                    theme="light"
                                    trigger="click"
                                    placement="bottom-end"
                                    content={
                                        <MarketplaceMenu
                                            handleShopClick={ this.handleShopClick }
                                            rewardsOffering={ user.rewardsOffering }
                                        />
                                    }
                                >
                                    <a href="#" className="redeem-menu btn">
                                        <span className="redeem-label"><LocaleString code="home.header.redeemMenuLabel" /></span>
                                        <span className="icon"><ChevronDownIcon /></span>
                                    </a>
                                </Tippy>
                            </div>
                        </div>
                    }
                </div>

            </div>
        );
    }

}

const UserHeader = ( { user, handleLogout } ) => {
    const launchedAsBar = user.adminAsUser &&
        <span className="launched-as-label">
            <LocaleString code="common.content.launchAsLabel" />
        </span>;

    return (
        <div className="user-header">
            <div className="container">
                <div className="user-info">

                    { launchedAsBar }

                    <Link to="/profile" className="profile-link">
                        <span className="name ">{ `${user.firstName} ${user.lastName}` }</span>
                        <span className="sr-only"> <LocaleString code="profile.page.header" /></span>
                    </Link>

                    <a href="#" className="logout-link" aria-label="Logout" onClick={ handleLogout }>
                        <LocaleString code="common.button.logoutLabel" />
                        <span className="logout-icon"><LogoutIcon /></span>
                    </a>

                </div>
            </div>
        </div>
    );
};

const MarketplaceMenu = ( { handleShopClick, rewardsOffering } ) => (
    <ul>
        { !!( rewardsOffering && rewardsOffering.merchandise ) &&
            <li>
                <a href="#" data-type="merchandise" onClick={ handleShopClick }>
                    <span className="icon"><MerchandiseIcon /></span>
                    <span className="link-label"><LocaleString code="home.header.shopLabel" /></span>
                </a>
            </li>
        }
        { !!( rewardsOffering && rewardsOffering.experiences ) &&
            <li>
                <a href="#" data-type="experiences" onClick={ handleShopClick }>
                    <span className="icon"><ExperiencesIcon /></span>
                    <span className="link-label"><LocaleString code="home.header.experiencesLabel" /></span>
                </a>
            </li>
        }
    </ul>
);


Header.propTypes = {
    clientLogo: PropTypes.string,
    user: PropTypes.object,
    logout: PropTypes.func
};

UserHeader.propTypes = {
    user: PropTypes.object,
    handleLogout: PropTypes.func
};

export default Header;
